import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/images/logo.svg";
import Logout from "@mui/icons-material/Logout";
import Drawer from "@mui/material/Drawer";
import { useState } from "react";
import SideBarMenu from "./SideBarMenu";
import useLocalStorage from "../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";

function Header({
  hideSideBar,
  setHideSideBar,
}: {
  hideSideBar?: boolean;
  setHideSideBar?: any;
}) {
  const [open, setOpen] = useState(false);
  const { name } = useLocalStorage();
  const navigate = useNavigate();

  const handelLogOut = () => {
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{ backgroundColor: (theme) => theme.palette.primary.light }}
      >
        <Box sx={{ px: 2 }}>
          <Toolbar disableGutters>
            <Box component="div" sx={{ display: { md: "flex", lg: "none" } }}>
              <IconButton
                onClick={() => setOpen(true)}
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <IconButton
              onClick={() => setHideSideBar(!hideSideBar)}
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ display: { xs: "none", lg: "flex" } }}
            >
              {hideSideBar ? (
                <OpenInFullIcon sx={{ fontSize: 32, mt: 1 }} />
              ) : (
                <CloseFullscreenIcon sx={{ fontSize: 32, mt: 1 }} />
              )}
            </IconButton>
            <Box component="div" sx={{ display: { xs: "flex", lg: "none" } }}>
              <img src={logo} width={60} height={60} />
            </Box>

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ flexGrow: 1 }}
            >
              <Typography
                variant="h6"
                noWrap
                component="a"
                href=""
                sx={{
                  mr: 6,
                  ml: 1,
                  flexGrow: 1,
                  fontFamily: "monospace",
                  fontWeight: 700,
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                MOTOLET
              </Typography>
              {name.length > 0 ? (
                <Typography sx={{ mr: 2 }}>{`welcome: ${name}`}</Typography>
              ) : (
                ""
              )}
              <IconButton onClick={handelLogOut} sx={{ cursor: "pointer" }}>
                <Logout sx={{ color: "common.white" }} />
              </IconButton>
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
      <Drawer open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 300, overflow: "hidden" }}>
          <SideBarMenu headerHeight={64} closeDrawer={setOpen} />
        </Box>
      </Drawer>
    </>
  );
}
export default Header;
